var CartoCSS = require('./cartocss');

/**
 * @namespace carto.style
 * @api
 */
module.exports = {
  CartoCSS: CartoCSS
};
